import { render, staticRenderFns } from "./ClickAndBuyForm.vue?vue&type=template&id=126d4df6&scoped=true"
import script from "./ClickAndBuyForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyForm.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyForm.vue?vue&type=style&index=0&id=126d4df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d4df6",
  null
  
)

export default component.exports